import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
  useToast,
} from "alm-react-components";
import Lottie from "lottie-react";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
 

import { ActionType, APPROUTES, FileNotation, StatusCode } from "../../../assets/constants/constants";
import { analytics_category, analytics_event, analytics_label } from '../../../assets/constants/staticContentConstants.ts';
import { AppContext } from "../../../context/AppProvider";
import useGaEventTracking from '../../../hooks/UseGaEventTracking.tsx';
import { courseComplete, getLottieFileContent } from "../../../services/user";
import { constants } from './../../../assets/constants/constants';
import closeImg from "./../../../assets/images/svgicons/close-sm.svg";
import { ProgramFinishButton } from "./ProgramFinishButton";
type FinishProgramBtnProps = {
  programDetailObject: any;
  programFinishLottieLocation: string;
  programBadgeLottieLocation: string;
  learningProgramStatus: any;
  courseDetails: any;
  isFundamentalProgram: boolean;
  programStatus:boolean,
  currentQuarter:any
  pId:string,
  badgeDetailData:any
};
 
const FinishProgram: React.FC<FinishProgramBtnProps> = ({
  programDetailObject,
  programFinishLottieLocation,
  programBadgeLottieLocation,
  learningProgramStatus,
  programStatus,
  courseDetails,
  isFundamentalProgram,
  currentQuarter,
  pId,
  badgeDetailData
}) => {
  const { toast } = useToast();
  const [show, setShow] = useState<boolean>(false);
  const [isAllProgramCompleted, setIsAllProgramCompleted] = useState(true);
  const { t } = useTranslation();
  const [step, setStep] = useState<number>(1);
  const [isProgramCompleted, setIsProgramCompleted] =
    useState<any>(programStatus);
  const finishedProgram = isAllProgramCompleted;
  const { state, dispatch } = useContext(AppContext);
  const gaEventTracker = useGaEventTracking();

  useEffect(()=>{
    let status=true;
     courseDetails?.filter((res: any) => res?.visible).map((week: any) => {
        week?.courseArray?.map((lession: any) => {
          if(lession?.mandatory)
          if(status)
           status = lession.state === constants.COMPLETED 
        })
    })
    setIsAllProgramCompleted(status)
  },[courseDetails]);

  const callProgramCompleteApi = () => {
    const parms = {
      dateCompleted: new Date(),
      dateStarted: new Date(),
      duration: 0,
      learningProgram: true,
      ...learningProgramStatus,
    };
    if (finishedProgram) {
      dispatch({ type: ActionType.SET_LOADING, payload: true });
      courseComplete(parms).then((res: any) => {
        dispatch({ type: ActionType.SET_LOADING, payload: false });

        if (res.status === StatusCode.SUCCESS) {
          setIsProgramCompleted(true)
          setShow(true);
          dispatch({type:ActionType.REFETCH_PROGRAM_DTATA, payload:state.refetchProgramData})
          const items = {
            value: null,
            currency: null,
            transaction_id: null,
            items: [{}],
            userId:state.user?.userId,
            program_name:programDetailObject.name,
            program_quarter:`${currentQuarter.quarter}-${currentQuarter.year}`,
            completion_date:programDetailObject.completionDeadline,
            badge_earned:"Yes",
            program_id:pId
        };      
      gaEventTracker(analytics_event.programCompleted,analytics_category.buttonClickProgramCompleted,analytics_label.programFinishedLable,items);
        } else {
          toast({
            description: t("Common.programCompletionError"),
            variant: "error",
          });
        }
      });
    } else {
      setShow(true);
    }
  };

  return (
    <div className="flex justify-end">
    <div className="flex flex-col gap-4 mt-8">
      <ProgramFinishButton
        isProgramCompleted={isProgramCompleted}
        finishedProgram={finishedProgram}
        callProgramCompleteApi={callProgramCompleteApi}
      />
      { show && <NotCompletedLession
        show={show}
        finishedProgram={finishedProgram}
        setShow={setShow}
        programDetailObject={programDetailObject}
        setStep={setStep}
        courseDetails={courseDetails}
        isFundamentalProgram={isFundamentalProgram}
        step={step}
        programFinishLottieLocation={programFinishLottieLocation}
        programBadgeLottieLocation={programBadgeLottieLocation}
        badgeDetailData={badgeDetailData}
      />}
    </div>
    </div>
  );
};
export default React.memo(FinishProgram);

const NotCompletedLession = React.memo(({
  show,
  finishedProgram,
  programDetailObject,
  setShow,
  setStep,
  step,
  programFinishLottieLocation,
  programBadgeLottieLocation,
  courseDetails,
  badgeDetailData,
  isFundamentalProgram
}: any) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useContext(AppContext);
  const gaEventTracker = useGaEventTracking();
  const [programFinishLoactionLottieJson, setProgramFinishLoactionLottieJson] =
    useState<string>("");
  const [programBadgeLoactionLottieJson, setProgramBadgeLottieLocationJson] =
    useState<string>("");

  const setLotteFile = (location: any, type: any) => {
    getLottieFileContent(location).then((res: any) => {
      if (res.status === StatusCode.SUCCESS) {
        if (type === FileNotation.badge) {
          setProgramBadgeLottieLocationJson(res.data);
        } else if (type === FileNotation.finish) {
          setProgramFinishLoactionLottieJson(res.data);
        }
      }
    });
  };
  useEffect(() => {
    if (finishedProgram) {
      setLotteFile(programFinishLottieLocation, FileNotation.finish);
      setLotteFile(programBadgeLottieLocation, FileNotation.badge);
    }
  }, [finishedProgram]);

  const closeModal = () => {
    setShow(false);
  };
  const items = {
    value: null,
    currency: null,
    transaction_id: null,
    items: [{}],
    userId:state.user?.userId,
    program_name:programDetailObject.name,
    badge_name:badgeDetailData?.name,
    date_earned:new Date(),
    program_id:programDetailObject.id
};

gaEventTracker(analytics_event.badgeEarned,analytics_category.buttonClickBadgeEarned,analytics_label.earnedBadgeLable,items);
  const doFinishProgram = (step: number) => {
    if (step === 1) {
      setStep(2);
    } else {
      setShow(false);
    }
  };
  const closeDialog = () => {
    setShow(false);
  };
  const nextProgram = () => {
    navigate(`${APPROUTES.myStance}?goToBadges=true`);
  };
  const dialogHeader = () => {
    return (
      <AlertDialogHeader className="justify-between flex-row absolute right-0 top-3">
        <AlertDialogCancel
          onClick={() => closeModal()}
          className="sm w-max border-0 bg-transparent hover:bg-transparent z-[2] hidden"
        >
          <img src={closeImg} alt={" "} className="w-[21px] h-[20px]" />
        </AlertDialogCancel>
      </AlertDialogHeader>
    );
  };
  const getMessage = () => {
    const message: any = [];
    courseDetails.forEach((week: any, windex: number) => {
      week?.courseArray?.forEach((course: any, index: number) => {
        if (course?.mandatory == true && course.state!== constants.COMPLETED){
          message.push(
            ` ${ isFundamentalProgram ? t("Common.part"): t("Common.week")} ${windex + 1} - ${t("Common.lesson")} ${
              index + 1
            }`
          );
        } 
      });
    });
    return <span className="dark:text-white">{message.join(", ")}</span>;
  };
  return (
    <AlertDialog open={show}>
      { finishedProgram ? (
        <AlertDialogContent className="bg-[#16171C] py-6 px-3 max-md:px-6 md:px-12 w-full text-center border border-primary overflow-hidden">
          {dialogHeader()}

          <AlertDialogTitle className="font-barlowRegular font-normal uppercase text-lg z-[1]">
            <span dangerouslySetInnerHTML={{ __html: t("Program.text") }} />
          </AlertDialogTitle>
          <AlertDialogDescription className="flex h-1/2 flex-col">
            <div className=" relative  z-[1]">
              <div className="flex justify-center">
                <h3 className="text-2xl font-barlowRegular text-white pb-6">
                  {programDetailObject.name}
                </h3>
              </div>
              <div className="hidden">
                <p className="mb-8 font-barlowLight uppercase text-2xl text-white">
                  <span dangerouslySetInnerHTML={{ __html: t("Common.completed") }} />!
                </p>
              </div>
            </div>

            <div className="max-sm:h-[322px] max-md:h-[380px] h-[435px] w-full md:w-[332px] relative left-0 z-0">
              <div className="flex justify-center">
                {step === 1 && (
                  <Lottie
                    animationData={programFinishLoactionLottieJson}
                    loop={true}
                    className="lottie-card"
                  />
                )}
                {step === 2 && (
                  <Link to={`/home/my-stance`}>
                    <Lottie
                      animationData={programBadgeLoactionLottieJson}
                      loop={true}
                      className="lottie-card"
                    />
                  </Link>
                )}
              </div>
            </div>
          </AlertDialogDescription>
          <AlertDialogFooter className="sm:justify-center z-[1]">
            {step === 1 ? (
              <Button
                variant={finishedProgram ? "default" : "secondary"}
                className=" max-sm:w-auto md:w-full font-opensansSemiBold text-base  mx-5 mt-6"
                onClick={() => doFinishProgram(step)}
              >
                <span dangerouslySetInnerHTML={{ __html: t("Common.getYourBadge") }} />
              </Button>
            ) : (
              <AlertDialogAction
                className=" max-sm:w-auto md:w-full font-opensansSemiBold text-base  mx-5 mt-6"
                onClick={() => nextProgram()}
              >
                {" "}
                <span dangerouslySetInnerHTML={{ __html: t("Common.nextProgram") }} />
              </AlertDialogAction>
            )}
          </AlertDialogFooter>
        </AlertDialogContent>
      ) : (
        <AlertDialogContent className="bg-[#16171C] border border-primary py-12 px-10 w-full text-center">
           <AlertDialogHeader className="justify-between flex-row">
            <h1 className="text-2xl font-barlowRegular dark:text-white text-center sm:text-center w-full">
              <span dangerouslySetInnerHTML={{ __html: t("Common.noProgramFinish") }} />
            </h1>
            <AlertDialogCancel
              onClick={() => closeModal()}
              className=" border-0 bg-transparent hover:bg-transparent absolute right-2 top-2 mt-0 z-[2]"
            >
              <img src={closeImg} alt={" "} className="w-[21px] h-[20px]" />
            </AlertDialogCancel>
          </AlertDialogHeader>
          <AlertDialogDescription>
            <p>
                <span className="dark:text-white" dangerouslySetInnerHTML={{ __html: t("Program.badgeEarnMeg") }} />
            </p>
            <p>
                <span className="dark:text-white" dangerouslySetInnerHTML={{ __html: t("Program.needToFinish") }} />
            </p>
            {getMessage()}
          </AlertDialogDescription>
          <AlertDialogFooter className="lg:justify-center mt-6">
            <AlertDialogAction
              onClick={() => closeDialog()}
              className="w-full font-opensansSemiBold text-base dark:bg-white hover:bg-white"
            >
              {" "}
              <span dangerouslySetInnerHTML={{ __html: t("Common.gotIt") }} />
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      )}
    </AlertDialog>
  );
});
